<script>
    export let type = 'text';
    export let value
</script>

{#if type === 'email'}
    <input type='email'
           id={$$props.id}
           name={$$props.name}
           placeholder={$$props.placeholder}
           disabled={$$props.disabled || false}
           required={$$props.required}
           bind:value={value}
           class='{$$props.class} flex-grow bg-neutral-100 hover:!bg-neutral-200 rounded-xl py-3 px-5 text-neutral-700'>
{:else if type === 'number'}
    <input type='number'
           id={$$props.id}
           name={$$props.name}
           placeholder={$$props.placeholder}
           disabled={$$props.disabled || false}
           required={$$props.required}
           bind:value={value}
           step={$$props.step || 1}
           class='{$$props.class} flex-grow bg-neutral-100 hover:!bg-neutral-200 rounded-xl py-3 px-5 text-neutral-700'>
{:else}
    <input type='text'
           id={$$props.id}
           name={$$props.name}
           placeholder={$$props.placeholder}
           disabled={$$props.disabled || false}
           required={$$props.required}
           bind:value={value}
           class='{$$props.class} flex-grow bg-neutral-100 hover:!bg-neutral-200 rounded-xl py-3 px-5 text-neutral-700'>
{/if}

